import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import headerRight from "../assets/images/inst-right-image.svg"




const Terms = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>
            <Header />
            <div className="instructions-wapper">
                <div className="instructions-pag">
                    <div className="instructions-page">
                        <div className="instructions-header">
                            <h3 className="txt-48 text-light">Terms & Conditions <br></br>Dermpath Academy & Diagnostics India Pvt Ltd (DADI)</h3>
                            <img src={headerRight} alt="" />
                        </div>
                        <div className="instructions-points">
                            <p className="greeting">Last Updated: June 13, 2025</p>

                            <div className="section">
                                <h2>Terms & Conditions</h2>
                                <ol className="custom-bullet">
                                    <li><strong>Acceptance of Terms:</strong> By accessing and using dermpathacademy.in (“the Site”), you agree to these Terms & Conditions (“Terms”). If you do not agree, please do not use the Site.</li>

                                    <li><strong>Eligibility:</strong> The Site and its services are intended for medical professionals (e.g., dermatologists, dermatopathologists, fellows). By registering, you affirm that you are authorized and eligible to participate.</li>

                                    <li>
                                        <strong>Account Registration:</strong>
                                        <ul>
                                            <li>You agree to provide accurate and complete information during registration.</li>
                                            <li>You are responsible for protecting your login credentials.</li>
                                            <li>You must notify us immediately of any unauthorized access to your account.</li>
                                        </ul>
                                    </li>

                                    <li>
                                        <strong>Use of the Site:</strong> The Site’s content and services are intended for personal, educational, and non-commercial use. You must not copy, distribute, modify, or otherwise exploit content without explicit permission.
                                    </li>

                                    <li>
                                        <strong>Submitted Content:</strong> Any content (e.g., forum posts, quiz responses) you submit remains your own, but by submitting, you grant DADI a worldwide, non-exclusive, royalty-free license to use, adapt, display, and distribute it in connection with the Site.
                                    </li>

                                    <li>
                                        <strong>Fees and Payments:</strong> While much of the Site is free, some features (e.g., quiz certificates, advanced modules) may require payment. Fees will be clearly displayed before purchase. Payments are non-refundable unless otherwise stated.
                                    </li>

                                    <li>
                                        <strong>Intellectual Property:</strong> All Site content (text, images, logos, videos) is protected under copyright and other applicable laws. Unauthorized use of Site materials is strictly prohibited.
                                    </li>

                                    <li>
                                        <strong>Disclaimer of Professional Advice:</strong> The Site provides educational material only and is not a substitute for professional diagnosis, treatment, or advice. Use the Site at your discretion and consult relevant professionals when needed.
                                    </li>

                                    <li>
                                        <strong>Limitation of Liability:</strong> DADI and its affiliates will not be liable for any indirect, incidental, or consequential damages arising from your use of the Site.
                                    </li>

                                    <li>
                                        <strong>Indemnification:</strong> You agree to indemnify and hold harmless DADI, its officers, staff, and partners against any claims or liabilities arising from your use of the Site or violation of these Terms.
                                    </li>

                                    <li>
                                        <strong>Modifications to Terms:</strong> We may update these Terms at any time; revised Terms apply upon posting. Continued use of the Site implies acceptance of any changes.
                                    </li>

                                    <li>
                                        <strong>Governing Law:</strong> These Terms are governed by the laws of India. Any disputes arising hereunder shall be subject to the exclusive jurisdiction of Indian courts.
                                    </li>

                                    <li>
                                        <strong>Contact Us:</strong> For questions regarding these Terms, please contact us:<br />
                                        Email: <a href="mailto:admin@dermpathacademy.in">admin@dermpathacademy.in</a><br />
                                        Address: Dermpath Academy & Diagnostics India Pvt Ltd, Dermpath Academy And Diagnostics India Private Limited 242 F/f, Sfs, Yusuf Sarai, Near Indian Oil Building, Gulmohar Park, New Delhi, South Delhi- 110049, Delhi
                                    </li>
                                </ol>
                            </div>



                            {/* <p className="signature text-center">
                                © 2025 Dermpath Academy & Diagnostics India Pvt Ltd. All rights reserved.
                            </p> */}
                        </div>
                    </div>
                    {/* <div className="d-flex justify-content-center pb-4">
                                     <button className="create-quiz-btn border-0">agree & continue</button>
                                 </div> */}
                </div>
            </div>
            <Footer />

        </>
    )
}

export default Terms;
